import { ComplexEnumItem } from '../../utils/complexEnum/ComplexEnumItem'

export class LotCompactionLevelItem<
  ID extends string,
  Label extends string,
  Description extends string,
  LevelMessage extends (options: any) => string
> extends ComplexEnumItem<ID> {
  readonly label: Label
  readonly description: Description
  readonly levelMessage: LevelMessage
  constructor({
    id,
    label,
    description,
    levelMessage,
  }: Pick<
    LotCompactionLevelItem<ID, Label, Description, LevelMessage>,
    'id' | 'label' | 'description' | 'levelMessage'
  >) {
    super(id)
    this.label = label
    this.description = description
    this.levelMessage = levelMessage
  }
}
